import React from "react"

import {kebabCase} from "lodash"
import PropTypes from "prop-types"

import colors from "../../styles/_default.colors.module.scss"
import Typography, {TYPOGRAPHY_VARIANTS} from "../Typography"

import "./segment.scss"

const Segment = ({
    autoHeight = false,
    body,
    className = "",
    header = {
        backgroundColor: "",
        color: "",
        content: null,
        withBorder: false,
    },
    isActive = false,
    isFixed = false,
}) => {
    // Permet de définir par une props le niveau de heading à appliquer sur le titre du body, h4 par default
    // Cela n'affecte pas le style, seulement le niveau de titre dans la hierarchie
    const bodyTitleAccessibilityHeading = body.titleAccessibilityHeading ? body.titleAccessibilityHeading : "h4"
    const bodyTitleId = body.title ? `segment-body-title-${kebabCase(body.title)}` : undefined

    // Si header.content contient un élément de titre avec ID, on l'utilise pour aria-labelledby
    let headerTitleId = null
    if (header?.content && React.isValidElement(header.content)) {
        const headerElement = header.content
        if (headerElement.type && typeof headerElement.type === "string" && /^h[1-6]$/i.test(headerElement.type)) {
            headerTitleId = headerElement.props?.id || null
        }
    }
    const segmentTitleId = headerTitleId || bodyTitleId || undefined

    return (
        <section
            aria-labelledby={segmentTitleId}
            className={`segment${isFixed ? " fixed" : ""}${autoHeight ? " auto-height" : ""}${
                className ? ` ${className}` : ""
            }`}
        >
            {header.content && (
                <header
                    className="segment-header"
                    style={{
                        backgroundColor: header.backgroundColor,
                        color: header.color,
                        border: header.withBorder
                            ? `solid 1px ${body.borderColor ? body.borderColor : colors.neutral300}`
                            : `none`,
                        borderBottom: "none",
                    }}
                >
                    {header.content}
                </header>
            )}
            <div
                className={`segment-body${header.content ? "" : " segment-body-border"}${
                    autoHeight ? " auto-height" : ""
                }`}
                style={{
                    backgroundColor: body.backgroundColor,
                    borderColor: body.borderColor ? body.borderColor : colors.neutral300,
                    color: body.color,
                    // Conditionnellement ajoute une bordure gauche si isActive est vrai
                    // Sinon, ne définit pas de bordure gauche dans le style
                    ...(isActive && {borderLeft: "0.25rem red solid"}),
                }}
            >
                {body.title && (
                    <Typography as={bodyTitleAccessibilityHeading} id={bodyTitleId} variant={TYPOGRAPHY_VARIANTS.H4}>
                        {body.title}
                    </Typography>
                )}
                {body.content}
            </div>
        </section>
    )
}

Segment.propTypes = {
    autoHeight: PropTypes.bool,
    body: PropTypes.shape({
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        color: PropTypes.string,
        content: PropTypes.element.isRequired,
        title: PropTypes.string,
        titleAccessibilityHeading: PropTypes.string,
    }).isRequired,
    className: PropTypes.string,
    header: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string,
        content: PropTypes.element,
        withBorder: PropTypes.bool,
    }),
    isActive: PropTypes.bool,
    isFixed: PropTypes.bool,
}

export default Segment
